import { render } from "./PathwayMappingTemplateList.vue?vue&type=template&id=691660b6"
import script from "./PathwayMappingTemplateList.vue?vue&type=script&setup=true&lang=js"
export * from "./PathwayMappingTemplateList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/PathwayMappingTemplateList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "691660b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('691660b6', __exports__)) {
    api.reload('691660b6', __exports__)
  }
  
  module.hot.accept("./PathwayMappingTemplateList.vue?vue&type=template&id=691660b6", () => {
    api.rerender('691660b6', render)
  })

}


export default __exports__